import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'app-menu-style1',
  templateUrl: './menu-style1.component.html',
  styleUrls: ['./menu-style1.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuStyle1Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/mega-menu/menu-style1/menu-style1.component.ts